/**
 * The Work orders page (SWOOP-325). It is the path the module registry declares for the Work-orders nav
 * surface (`modules.ts`, Maintenance → nav), so the route guard and `<ModuleGate>` look the owning
 * module up there (`moduleAreaForPath`) rather than naming it — Maintenance owns the screen through the
 * registry alone.
 */
export const WORK_ORDERS_PATH = '/work-orders';

/** Seeing the Work orders page. */
export const WORK_ORDERS_LIST_PERMISSION = 'work-orders:list';

/** Opening a work order (the "Open work order" button and drawer). */
export const WORK_ORDERS_MANAGE_PERMISSION = 'work-orders:manage';
